import * as React from 'react';

import { Grid, Header } from 'semantic-ui-react';
import { InstanceList } from './InstanceList'; 
import { CtrlPanel } from './CtrlPanel'; 

export class Webapp extends React.Component {
    constructor(props: any, context: any) {
        super(props, context);
        
    }
    public render() {
        return <Grid id='ui-container' >
        <Grid.Column width={1}></Grid.Column>
        <Grid.Column width={4}>
            <Header as='h4' dividing>Legends</Header>
            <CtrlPanel/>
        </Grid.Column>
        <Grid.Column width={10} className='container full-height'>
            <Header as='h4' dividing>Instances</Header>
            { <div id='question-list' className='container question overflow'><InstanceList/></div> }
        </Grid.Column>
    </Grid>
    }
}



// WEBPACK FOOTER //
// ./src/components/Webapp.tsx